import { TipoItem, Udm, Moneda } from "../../../isp.žapi.items/constantesApiItems";

const tiposItem = [
    { label: "Plan de Internet", value: TipoItem.PlanInternet },
    { label: "Servicios Gener.", value: TipoItem.ServiciosGen },
    { label: "Articulo", value: TipoItem.Articulo },
];

const udms = [
    // { label: "Mensual", value: Udm.Mensual },
    { label: "Unidad", value: Udm.Unidad },
];

const monedas = [
    { label: "Soles (S/)", value: Moneda.Soles },
    { label: "Dólares ($)", value: Moneda.Dolares },
];

export { tiposItem, udms, monedas };
